<template>
  <div class="findpswd">
    <!-- 返回上级 -->
    <div class="back" @cilck="backFn">
      <img
        src="../../../static/img/gzs/icon/icon_back -B.png"
        alt=""
      />
    </div>
    <div class="text">
      找回密码
    </div>
    <div class="inpList">
      <div class="phone">
        <input type="number" maxlength="11" placeholder="请输入手机号" @input="retriephoneInput" v-model="retriePhonenum">
      </div>
      <div class="imgVer">
        <input type="text" v-model="imgNum" placeholder="请输入图形验证码"><img @click="tux" :src="srcImg" alt="">
      </div>
      <div class="numVer">
        <input type="text" v-model="SixNum" placeholder="请输入手机验证码">
        <button :style="{background:background}" :disabled="disable" @click="getVer">{{ text }}</button>
      </div>
      <div class="Pssword">
        <input v-model="PassNum" placeholder="请设置6～20位英文/数字密码" :type="passwordType">
      </div>
      <div class="btn">
        <button @click="reset">重置密码</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../util/gaeaApiConfig";
import http2 from "../../util/hermerApiConfig";

export default {

  data() {
    return {
      text: "获取验证码",
      background: "#DEB7B0",
      disable: true,
      isIcon: true,
      passwordLogin: true,
      imgNum: "",
      SixNum: "",
      PassNum: "",
      passwordType: "password",
      retriePhonenum: "",
      isLogin: false,
      tips: "",
      retrievecount: 60,
      radio: "",
      switchVal: false,
      // okNo: true,
      srcImg: "",
      form: {
        phone: "",
        yzm: "",
        tx: "",
      },
    };
  },
  mounted() {
    // 图形验证码
    this.getcaptcha();
  },
  methods: {
    retriephoneInput(){
      this.background='#AC4B38'
      this.disable=false
    },
    // 获取图形验证码
    getcaptcha() {
      http.get('get_captcha').then((res) => {
        this.srcImg = res.data;
      });
    },
    // 返回上级
    backFn() {
      this.$router.push({
        path:'/order_login'
      })
    },
    tux(){
      this.getcaptcha();
    },
    getVer() {
      let phoneInpText = this.retriePhonenum
      let reg = /^1[3|4|5|7|8][0-9]{9}$/;
      const TIME_COUNT = 60;
      if (reg.test(phoneInpText)) {
        this.retrievecount = TIME_COUNT;
        this.background = "#DEB7B0"
        let data = {}
        data.phone = phoneInpText
        data.area_code = '86'
        data.type = 'forget_pwd'
        data.platform = 'h5'
        http.post('sms_code',data).then(res => {
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
        this.timer = setInterval(() => {
          ;
          if (this.retrievecount > 0 && this.retrievecount <= TIME_COUNT) {
            this.retrievecount--;
            this.disable = true
            this.text = this.retrievecount-- +"秒后重新获取"
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.disable=false
            this.text = "重新获取"
          }
        }, 1000)
      } else {
        alert('手机号错误请重新输入')
        this.retriePhonenum = ''
      }
    },
    // 找回密码请求
    reset() {
      if (this.retriePhonenum == '' && this.retriePhonenum == null) {
        alert('请输入手机号')
      } else if (this.imgNum == '' && this.imgNum == null) {
        alert('请输入图形验证码')
      } else if (this.SixNum == '' && this.SixNum == null) {
        alert('请输入验证码')
      } else if (this.PassNum == '' && this.PassNum == null) {
        alert('请输入密码')
      } else {
        let data = {}
        data.phone = this.retriePhonenum;
        data.area_code = "86";
        data.captcha_code = this.imgNum;
        data.reset_password = this.PassNum;
        data.sms_code = this.SixNum;
        console.log(data)
        http().post('users/find_pwd', data).then(res => {
          this.$router.push({
            path:'/order_login'
          })
        }).catch(err => {
          console.log(err)
        })
      }
    },
    //密码是否可见
    shouHide() {
      this.okNo = !this.okNo;
      if (this.passwordType == "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    shoujihao(v) {
      //console.log(v);
      if (this.form.phone != "" && this.form.yzm != "") {
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
    yanzhengma(v) {
    },
    codeChange(text) {
      this.tips = text;
    },
    // 获取短信验证码
    getCode() {
      if (this.$refs.uCode.canGetCode) {
        uni.request({
          url: "http://proxy.jiankanghao.net:50255/api/v1/sms_code", //仅为示例，并非真实接口地址。
          data: {
            phone: this.form.phone,
            type: "login",
            area_code: "86",
          },
          method: "POST",
          header: {
            // 'custom-header': 'hello' //自定义请求头信息
          },
          success: (res) => {
            this.$u.toast("验证码已发送");
            this.$refs.uCode.start();
            //console.log("验证码------------", res);
            // this.text = 'request success';
          },
        });
      } else {
        this.$u.toast("请稍等");
      }
    },
    start() {
      this.$u.toast("发送成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.findpswd {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .back {
    width: 100%;
    height: 3rem;
    padding-left: .5rem;
    box-sizing: border-box;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .text {
    width: 100%;
    height: 3rem;
    padding-left: 35px;
    padding-right: 35px;
    box-sizing: border-box;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 1.5rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
  }

  .inpList {
    width: 100%;
    padding-left: 35px;
    padding-right: 35px;
    box-sizing: border-box;

    .phone {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #ccc;

      input {
        width: 100%;
        height: 100%;
        border: none;
        background: #fff;
      }
    }

    .imgVer {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;

      input {
        flex: 1;
        border: none;
        background: #fff;
      }

      img {
        width: 100px;
        height: 40px;
      }
    }

    .numVer {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;

      input {
        flex: 1;
        border: none;
        background: #fff;
      }

      button {
        width: 100px;
        height: 40px;
        border-radius: 0.5rem;
        color: #fff;
      }
    }

    .Pssword {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #ccc;
      margin-top: 10px;

      input {
        width: 100%;
        height: 100%;
        border: none;
        background: #fff;
      }
    }

    .btn {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;

      button {
        width: 100%;
        color: #fff;
        height: 3.13rem;
        background: #AC4B38;
        border-radius: 0.75rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/findPassword.vue